import { Drivers } from '@ionic/storage';

enum InternalDrivers {
  SQLITE = 'sqlite',
}

export const StorageDrivers = { ...InternalDrivers, ...Drivers };
